import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles: any = makeStyles((theme: Theme) => {
    return {
        mainContainer: {
            display: "flex",
            flexDirection: "row",
            backgroundImage: `url(${theme.images.precisionImpactImage})`,
            backgroundRepeat: "no-repeat",
            padding: 24,
            justifyContent: "space-between",
            position: "relative",
            marginTop: 20,
            backgroundSize: 120,
            backgroundPosition: "center left",
            marginBottom: 20,
            backgroundColor: "#ebebf6",
        },
        mainContainerNoButton: {
            display: "flex",
            flexDirection: "row",
            backgroundImage: `url(${theme.images.precisionImpactImage})`,
            backgroundRepeat: "no-repeat",
            padding: 24,
            justifyContent: "space-between",
            position: "relative",
            marginTop: 20,
            backgroundSize: "contain",
            backgroundPosition: "13px 0",
            marginBottom: 20,
            backgroundColor: "#ebebf6",
        },
        mainContainerMobile: {
            display: "flex",
            flexDirection: "column",
            padding: 24,
            justifyContent: "space-between",
            position: "relative",
            marginTop: 20,
            marginBottom: 20,
            backgroundColor: "#ebebf6",
        },
        textContainer: {
            display: "flex",
            flexDirection: "column",
        },
        closeIcon: {
            color: "#424242",
            cursor: "pointer",
            alignSelf: "flex-end",
            position: "relative",
            top: -11,
            right: -12,
        },
        closeIconMobile: {
            position: "absolute",
            top: 5,
            right: 5,
        },
        co2Logo: {
            position: "absolute",
            top: -25,
            left: -35,
        },
        co2LogoMobile: {
            position: "absolute",
            top: -25,
            left: -20,
        },
        buttonsContainer: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            gap: 15,
        },
        title: {
            fontSize: "18px !important",
        },
        text: {
            fontSize: "16px !important",
        },
    };
});
